const Request = require('@/repositories/request')

class ProjectRoles extends Request {
  create({ user, project, employeeType }) {
    return this.$strapi['$project-roles'].create({
      user,
      project,
      employee_type: employeeType,
    })
  }

  findInActiveProjects() {
    return this.$strapi.$http.$get(`/project-roles/in-active-projects`)
  }

  findWithSupervisorAssignmentByProjectId(projectId) {
    return this.$strapi.$http.$get(
      `/project-roles/with-supervisor-assignment-by-project/${projectId}`
    )
  }

  findSupervisorProjectByCompanyId(companyId) {
    return this.$strapi.$http.$get(
      `/project-roles/supervisors-projects-by-company/${companyId}`
    )
  }

  findSupervisorProjectsByUserId(userId) {
    return this.$strapi.$http.$get(
      `/project-roles/supervisors-projects-by-user/${userId}`
    )
  }

  update(id, data) {
    return this.$strapi['$project-roles'].update(id, data)
  }

  delete(id) {
    return this.$strapi['$project-roles'].update(id, {
      deleted_at: new Date().toISOString(),
    })
  }

  findProjectRoleInfoByProjectCode(projectCode) {
    return this.$strapi.$http.$get(
      `/project-roles/project_role_info/${projectCode}`
    )
  }

  updateValidationStatus(projectId, supervisorId, notify = false) {
    // TODO: separar en dos endpoints, uno para el usuario empresa y otro para el usuario empleado(sin pasar supervisorId)
    if (notify) {
      return this.$strapi.$http.$put(
        `/project-roles/update-validation-status/${projectId}/${supervisorId}?notify=true`
      )
    }
    return this.$strapi.$http.$put(
      `/project-roles/update-validation-status/${projectId}/${supervisorId}`
    )
  }

  deleteSupervisorsCollaboratorsByProject(projectId) {
    return this.$strapi.$http.$delete(`/project-roles/by-project/${projectId}`)
  }
}

module.exports = ProjectRoles
